import { useState } from "react";
import PropTypes from "prop-types";
import { isBrowser } from "@helpers/browser";
import { cn, validateEmail } from "@helpers/general";
import { useALError } from "../../helpers/ErrorBoundary/ALErrorBoundary";
import { ComponentType } from "@constants/ComponentType";
import IconArrow from "../icons/svgs/arrow.svg";

function CaptureEmail({
  exponeaEventName = "",
  bloutoutEventName = "Subscribe Footer",
  componentType,
}) {
  const isBlog = componentType === ComponentType.BLOG_ARTICLE;
  const { sendReport } = useALError();
  const [userEmail, updateUserEmail] = useState(null);
  const [errorEmail, updateErrorEmail] = useState(null);
  const [hasSubscribe, updateSubscribe] = useState(false);

  const addCustomer = () => {
    if (isBrowser) {
      if (userEmail !== null) {
        const isValid = validateEmail(userEmail);
        if (isValid) {
          try {
            window.exponea.identify(
              {
                email_id: userEmail,
              },
              {
                email: userEmail,
              }
            );

            try {
              window.edgetag("user", "email", userEmail);
              window.edgetag("tag", "Lead", {
                name: bloutoutEventName,
              });
            } catch (error) {
              sendReport(error, { name: "CaptureEmail", priority: "P2" });
            }

            /* eslint-disable no-undef */
            exponea.track(exponeaEventName);

            updateSubscribe(true);
          } catch (error) {
            console.log("exponea_footer");
            console.log(error);
          }
        } else {
          updateErrorEmail("Please enter a valid email address.");
        }
      } else {
        updateErrorEmail("Please enter an email address");
      }
    }
  };

  return (
    <div
      className={cn(
        isBlog && "bg-black rounded-[4px] px-[15px] py-[30px] mb-[40px] desktop:mb-[30px]"
      )}
    >
      <p
        className={cn(
          "typo-body font-bold mb-[20px] mobile:typo-h3 mobile:mb-[15px]",
          isBlog ? "text-white" : "text-black"
        )}
      >
        Be the first to know
      </p>
      <p
        className={cn(
          "typo-micro mb-[20px] mobile:typo-body mobile:mb-[15px]",
          isBlog ? "text-white" : "text-black"
        )}
      >
        Sign up to receive insider information on exclusive offers and new arrivals.
      </p>
      <div className="flex flex-row items-center gap-[10px]">
        {!hasSubscribe ? (
          <>
            <input
              className={cn(
                "typo-micro px-[15px] py-[12px] border rounded-[4px] w-[calc(100%-60px)] mobile:w-[calc(100%-57px)]",
                isBlog
                  ? "bg-black text-white border-white placeholder:text-white"
                  : "text-black border-dark-grey"
              )}
              type="text"
              placeholder="Enter email"
              aria-label="Enter email to receive insider information on exclusive offers and new arrivals"
              onChange={(e) => {
                if (errorEmail !== null) {
                  updateErrorEmail(null);
                }
                updateUserEmail(e.target.value);
              }}
            />
            <button
              type="submit"
              aria-label="Submit"
              className={cn(
                "w-[39px] h-[39px] mobile:w-[37px] mobile:h-[37px] border rounded-[4px] flex items-center justify-center shrink-0",
                isBlog ? "border-white" : "border-dark-grey"
              )}
              onClick={addCustomer}
            >
              <IconArrow
                width="8"
                height="16"
                fill={isBlog ? "white" : "#898786"}
                style={{ transform: "rotate(180deg)" }}
              />
            </button>
            {errorEmail ? (
              <p className={cn("typo-micro", isBlog ? "text-white" : "text-black")}>{errorEmail}</p>
            ) : null}
          </>
        ) : (
          <p className={cn("typo-micro", isBlog ? "text-white" : "text-black")}>Thank you!</p>
        )}
      </div>
    </div>
  );
}

CaptureEmail.propTypes = {
  exponeaEventName: PropTypes.string,
  bloutoutEventName: PropTypes.string,
  componentType: PropTypes.string,
};

export default CaptureEmail;
